module.exports = __webpack_public_path__ + "static/img/JaneBunn.c9b55fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JaneBunn.jpg
// module id = KsgB
// module chunks = 0